import React, { useState, useEffect } from "react";
import styles from "../css/styles.module.css";
import SearchBar from "./searchBar";
import AddReport from "./addReport";
import EditReport from "./editReport";
import { db } from "../config/firebase";
import trash from "../images/delete.png";
import firebase from "firebase/compat/app";

export default function Dashboard(props) {
  const [data, setData] = useState(null);
  const [add, setAdd] = useState(false);
  const [remove, setRemove] = useState(false);
  const [customerSearch, setCustomerSearch] = useState(null);
  const [responsibleSearch, setResponsibleSearch] = useState(null);
  const [numberSearch, setNumberSearch] = useState(null);
  const [edit, setEdit] = useState(false);
  const [chosenReport, setChosenReport] = useState(null);

  const departments = [
    { label: "Service/Survey", value: "department" },
    { label: "Repair/Service", value: "department" },
    { label: "Accessory", value: "department" },
    { label: "3D Products", value: "department" },
    { label: "3D Services", value: "department" },
    { label: "Survey Product", value: "department" },
  ];

  useEffect(() => {
    setData(props.data);
    //creating data label to be use to searching be react select component
    if (props.responsible) {
      setResponsibleSearch(
        createSearchOptions(props.responsible, "responsible")
      );
    }
    if (props.qtNumber) {
      setNumberSearch(createSearchOptions(props.qtNumber, "qtNumber"));
    }
    if (props.customer) {
      let temp = props.customer.map((c) => c.label);
      setCustomerSearch(createSearchOptions(temp, "customer"));
    }
  }, [props.data, props.customer, props.responsible, props.qtNumber]);

  //handling add button click which will display add form
  function handleAddClick() {
    setAdd(true);
  }

  //handle the edit button being click by displaying the edit form
  function handleEditClick(report) {
    //sanitise the variable first by truning firbase timestamp in js date
    setChosenReport({
      id: report.id,
      customer: report.data.customer,
      contact: report.data.contact,
      department: report.data.department,
      detail: report.data.detail,
      qtNumber: report.data.qtNumber,
      responsible: report.data.responsible,
      timestamp: report.data.timestamp.toDate().toISOString().slice(0 , 10),
    });
    setEdit(true);
  }

  //handling adding new data to firestore
  function handleAddSubmit(e, newReport) {
    e.preventDefault();
    setAdd(false);
    db.collection("salesReport")
      .add({
        customer: newReport.customer,
        contact: newReport.contact,
        department: newReport.department,
        detail: newReport.detail,
        qtNumber: newReport.qtNumber,
        responsible: newReport.responsible,
        timestamp: firebase.firestore.Timestamp.fromDate(createDateTime(newReport.date)),
      })
      .then(() => {
        console.log("Success");
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //handle edit form submit by updating the chosen report's record
  function handleEditSubmit(e, report) {
    e.preventDefault();
    setEdit(false);
    db.collection("salesReport")
      .doc(chosenReport.id)
      .set({
        customer: report.customer,
        contact: report.contact,
        department: report.department,
        detail: report.detail,
        qtNumber: report.qtNumber,
        responsible: report.responsible,
        timestamp: firebase.firestore.Timestamp.fromDate(createDateTime(report.date)),
      })
      .catch((err) => {
        console.log(err);
      });
  }

  //handling user clicking cancel at the add form
  function handleCancelClick() {
    setAdd(false);
    setEdit(false);
  }

  //handling delete button click which will display the trash icon on each row in the table
  function handleDeleteStartClick() {
    setRemove(!remove);
  }

  //handling trash icon click which will delete the data of that row from firestore
  function handleDeleteClick(key) {
    db.collection("salesReport").doc(key).delete();
  }

  function handleSelectChange(selected) {
    //if selected input matches the customer value then only show match value
    let temp = [];
    if (selected) {
      selected.forEach((select) => {
        //if this is the first search criteria
        if (temp.length === 0) { 
          temp = props.data.filter((d) => {
            return d.data[select.value] === select.label;
          });
        } else {
          //multi searching
          temp = temp.filter((d) => {
            return d.data[select.value] === select.label;
          });
        }
      });
      setData(temp);
    } else {
      //else display all the data
      setData(props.data);
    }
  }

  //format timestamp into a more readable format
  function formatDate(date) {
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    let temp = new Intl.DateTimeFormat("default", options).format(date);
    return temp;
  }

  //create a date + time that firestore can store as a timestamp
  function createDateTime(dateString){
    let hour = new Date().getHours();
    let minute = new Date().getMinutes();
    //if time variables are not 2 digit then add a 0 infront
    if(hour < 10){
      hour = "0" + hour;
    }
    if(minute < 10){
      minute = "0" + minute;
    }
    return(new Date(dateString + "T" + hour + ":" + minute));
  }

  //create search label object from an array that will be used in a react-select component
  function createSearchOptions(array, group) {
    let temp = [];
    array.map((name) => {
      return temp.push({
        label: name,
        value: group,
      });
    });
    return temp;
  }

  //if add button is clicked, show the add data form
  if (add) {
    return (
      <div className={styles.addContainer}>
        <AddReport
          handleAddSubmit={handleAddSubmit}
          handleCancelClick={handleCancelClick}
          customer={props.customer}
          departments={departments}
          contact={props.contactName}
        />
      </div>
    );
  } else if (edit) {
    return (
      <div className={styles.addContainer}>
        <EditReport
          handleEditSubmit={handleEditSubmit}
          handleCancelClick={handleCancelClick}
          customer={props.customer}
          departments={departments}
          contact={props.contactName}
          report={chosenReport}
        />
      </div>
    );
  } else {
    //else show the data table
    return (
      <div className={styles.subContent}>
        <div className={styles.contentHeaderContainer}>
          <h1>Sales Report</h1>
          <SearchBar
            options={[
              {
                label: "Customers",
                options: customerSearch,
              },
              {
                label: "Departments",
                options: departments,
              },
              {
                label: "Responsible",
                options: responsibleSearch,
              },
              {
                label: "QT Number",
                options: numberSearch,
              },
            ]}
            isMulti={true}
            isClearable={false}
            placeholder="Search..."
            errorMessage="No customer with that name"
            handleSelectChange={handleSelectChange}
          />
          <div className={styles.buttonContainer}>
            <button onClick={handleAddClick} className={styles.addButton}>
              Add +
            </button>
            <button
              onClick={handleDeleteStartClick}
              className={styles.deleteButton}
            >
              {remove ? "Cancel" : "Delete -"}
            </button>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <td>Customer</td>
                <td>Contact</td>
                <td className={styles.large}>Details</td>
                <td>Department</td>
                <td>Person Responsible</td>
                <td>QT Number</td>
                <td>Timestamp</td>
                <td className={styles.small}></td>
                {remove && <td className={styles.small}></td>}
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((report) => {
                  return (
                    <tr key={report.id}>
                      <td>{report.data.customer}</td>
                      <td>{report.data.contact}</td>
                      <td>{report.data.detail}</td>
                      <td>{report.data.department}</td>
                      <td>{report.data.responsible}</td>
                      <td>{report.data.qtNumber}</td>
                      <td>{formatDate(report.data.timestamp.toDate())}</td>
                      <td
                        className={styles.editButton}
                        onClick={() => handleEditClick(report)}
                      >
                        Edit
                      </td>
                      {remove && (
                        <td
                          className={styles.trashButton}
                          onClick={() => handleDeleteClick(report.id)}
                        >
                          <img src={trash} alt="delete" />
                        </td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
